<template>
  <label :class="['input-checkbox', stateClasses]">
    <input
      type="checkbox"
      :value="value"
      :checked="isSelected"
      :disabled="disabled"
      @change="toggleCheck"
      @focus="focused = true"
      @blur="focused = false"
    />
    <div :class="['input-label']">
      <span>{{label}}</span>
      <slot></slot>
    </div>
  </label>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "checkbox",
  model: {
    prop: "model",
    event: "change"
  },

  props: {
    model: {
      type: [String, Boolean, Object, Number, Array],
      required: true
    },
    value: {
      type: [String, Boolean, Object, Number],
      required: true
    },
    falseValue: {
      default: false
    },
    label: String,
    disabled: Boolean,
    checked: Boolean
  },

  data: () => ({
    focused: false
  }),

  computed: {
    isModelArray() {
      return Array.isArray(this.model);
    },
    isValueObject() {
      return this.value !== null && typeof this.value === "object";
    },
    isSelected() {
      const { model, value, isEqual, isValueObject, isModelArray } = this;

      if (isModelArray) {
        if (isValueObject) {
          return model.some(obj => isEqual(obj, value));
        } else {
          return model.includes(value);
        }
      }

      if (isValueObject) {
        return isEqual(model, value);
      }

      return model === value;
    },
    stateClasses() {
      return {
        checked: this.isSelected,
        focused: this.focused,
        disabled: this.disabled
      };
    }
  },

  methods: {
    toggleCheck() {
      if (!this.disabled) {
        if (this.isModelArray) {
          this.handleArrayCheckbox();
        } else {
          this.handleSingleSelectCheckbox();
        }
      }
    },
    handleArrayCheckbox() {
      const newModel = this.model;

      if (!this.isSelected) {
        this.addValueToModel(newModel);
      } else {
        this.removeValueFromModel(newModel);
      }
    },
    handleSingleSelectCheckbox() {
      this.$emit("change", this.isSelected ? this.falseValue : this.value);
    },
    removeValueFromModel(newModel) {
      if (this.isValueObject) {
        newModel = newModel.filter(obj => !this.isEqual(obj, this.value));
      } else {
        const index = newModel.indexOf(this.value);

        if (index !== -1) {
          newModel.splice(index, 1);
        }
      }

      this.$emit("change", newModel);
    },
    addValueToModel(newModel) {
      newModel.push(this.value);

      this.$emit("change", newModel);
    },
    isEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  }
};
</script>
